import PropTypes from 'prop-types';
import React from 'react';
import { actionTypes } from '../../constants';
import i18next from "../../i18n";
import { Table } from '../table/Table';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { EditSignerForm, SignerFormTypes } from './EditSignerForm';
export class SignersTableForm extends React.Component {
    static propTypes = {
        handleAddSigner: PropTypes.func,
        handleDeleteSigners: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            sortBy: '',
            signers: this.props.signers ? this.props.signers : [],
            isDesk: false,
            columns: [
                {
                    headerName: "id",
                    hidden: true,
                    id: "0",
                    name: "Id",
                    type: "string"
                },
                {
                    canSort: true,
                    headerName: i18next.t("fullName"),
                    id: "1",
                    name: "SubscriberPIB",
                    type: "string"
                },
                {
                    canSort: true,
                    headerName: i18next.t("positionHeld"),
                    id: "2",
                    name: "SubscriberPosition",
                    type: "string"
                },
                {
                    canSort: true,
                    headerName: i18next.t("phone"),
                    id: "3",
                    name: "SubscriberPhone",
                    type: "phone"
                },
                {
                    canSort: true,
                    headerName: i18next.t("email"),
                    id: "4",
                    name: "SubscriberEmail",
                    type: "email"
                }
            ]
        };
        this.handleSortChange = this.handleSortChange.bind(this);
        this.actionHandlerCallback = this.actionHandlerCallback.bind(this);
    }
	actionHandlerCallback(actionType, ids) {
		const { signers, formMode } = this.state;
		let currentObject = this;
        if (this.props.actionHandlerCallback)
            this.props.actionHandlerCallback(actionType, ids);
		if (signers && signers.length > 0) {
			switch (actionType) {
				case actionTypes.remove:
					{
						let closeDialog = function () {
							hideModalDialog('modalDialog');
						}
						let confirmDialog = function () {
							closeDialog();
							currentObject.props.handleDeleteSigners(ids);
                        }
                        let message = signers.some(s => ids.includes(s.columns.Id) && s.columns.IsAccountant) ? i18next.t("removeSignatoriesWithAccountantMessage") : i18next.t("removeSignatoriesMessage")
                        showModalDialog('modalDialog', i18next.t("removing"), "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: confirmDialog, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: closeDialog, class: "btn-secondary" }]);
						break;
					}
				case actionTypes.edit:
					{
						showModalDialog('modalDialog', i18next.t("editSignatoryInfo"), "", <EditSignerForm formType={SignerFormTypes.edit} user={signers.filter(s => s.columns.Id === ids[0])[0].columns} onSubmitHandler={this.props.handleAddSigner.bind(this)} onCloseHandler={() => hideModalDialog('modalDialog')} />, "feedPopup with-header-btns");
						break;
					}
				case actionTypes.preview:
					let handleOnStartEdit = function () {
						currentObject.actionHandlerCallback(actionTypes.edit, ids);
					}
					showModalDialog('modalDialog', i18next.t("signatoryInformation"), "", <EditSignerForm formType={SignerFormTypes.view} user={signers.filter(s => s.columns.Id === ids[0])[0].columns} handleOnStartEdit={handleOnStartEdit} onCloseHandler={() => hideModalDialog('modalDialog')} formMode={formMode} />, "feedPopup with-header-btns");
					break;
				default:
					break;
			}
		}
	}
    componentDidUpdate() {
        if (this.props.signers && this.props.signers !== this.state.signers) {
            this.setState({ signers: this.props.signers });
        }
    }
    handleSortChange(sortBy, isDesk) {
        this.setState({ sortBy: sortBy, isDesk: isDesk });
    }
    render() {
        let { sortBy, isDesk, columns, signers } = this.state;
        if (!sortBy) {
            sortBy = "SubscriberPIB";
        }
        signers.sort(function (s1, s2) {
            var index1 = s1.columns[sortBy];
            var index2 = s2.columns[sortBy];
            if (index1 === null || index1 === undefined)
                index1 = 0;
            if (index2 === null || index2 === undefined)
                index2 = 0;
            let result = 0;
            if (index1 < index2) result = -1;
            if (index1 > index2) result = 1;
            if (isDesk)
                result *= -1;
            return result;
        })
        return (
            <div className="large-form doc-form">
                <Table name={SignersTableForm.name} allowDoubleClickAction={true} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} columns={columns} items={signers} sortBy={sortBy} isDesk={isDesk} pageSize={Number.MAX_SAFE_INTEGER} />
            </div>
        );
    }
}